<template>
  <div class="form">
    <div class="container">
      <div class="form-container text-left">
        <button @click="$router.go(-1)" class="app-btn px-3 mb-4">
          <v-icon class="mr-3 white-icon" name="arrow-left" scale="1"/> Atrás
        </button>
        <div class="d-flex justify-content-between">
          <span>
            <img src="https://img.icons8.com/material/24/000000/calendar--v1.png"/>
            Fecha de solicitud: {{requestDetail.createdDate | formatDate}}
          </span>
          <div class="d-flex">
              <div class="application-number mr-2">
                Solicitud - <span v-if="requestDetail.conectionType == 'Simple'">UPB</span> <span v-if="requestDetail.conectionType == 'Compleja'">UPM</span>
              </div>
              <div class="application-number">
                #{{requestDetail.id}}
              </div>
          </div>
        </div>
        <h2>Liquidación de pagos por diseño</h2>
        <div class="alert alert-info">
        <span v-if="requestDetail.conectionType == 'Simple'">
            los correos  lasandoval@emcali.com.co y conexión_simple_bt@emcali.com.co.</span> <span v-if="requestDetail.conectionType == 'Compleja'">Cuando realice el pago, adjuntar la copia y adicional enviar el soporte de pago a los correos elnavia@emcali.com.co, jenrodriguez@emcali.com.co, dlramirez@emcali.com.co</span>  
        </div>
        <div class="input-wrap">
            <div class="mb-3">
                <label class="file">Cargar comprobante de pago de liquidación<v-icon class="ml-3" name="upload" scale="1.5"/>
                    <input @change="onFileChangeDocument($event)" type="file">
                    <div class="file-selected" v-if="liquidationData.document">
                      {{liquidationData.documentFile.name}} - 
                    <button type="button" class="close" @click="confirmedDoc = true; validarInputDocument()">
                      <span><v-icon class="ml-1" name="trash" scale="1.5"/></span>
                    </button>
                    </div>
                </label> 
            </div>
          <div>
            <button @click="confirmed = true; validarInput()" class="app-btn app-btn--blue w-100">
              Enviar Información
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <div v-if="confirmed == false" class="error-modal">
      <div @click="confirmAccept = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Realmente desea enviar la información?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAccept = true; confirmed = true; sendRequest()" class="app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAccept = false; confirmed = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="confirmedDoc == false" class="error-modal">
      <div @click="confirmAcceptDoc = false" class="backdrop"></div>
      <div class="modal-box">
          <div class="d-flex justify-content-center app-icon mb-2">
            <v-icon name="exclamation-triangle" scale="2"/>
          </div>
          <div class="mb-4">
            ¿Esta seguro de borrar el documento?
          </div>
          <div class="d-flex justify-content-center mb-6">
          <div class=" px-4 mr-3">
            <button @click="confirmAcceptDoc = true; confirmedDoc = true; borrarDocumento()" class="app-btn app-btn">ACEPTAR</button>
          </div>
          <div class=" px-4 mr-3 ">
            <button @click="confirmAcceptDoc = false; confirmedDoc = true" class="app-btn app-btn--blue">CANCELAR</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';
import axios from "axios";

export default {
  data(){
    return {
      date: new Date(),
      options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      confirmedDoc: true,
      confirmAcceptDoc: false,
      confirmed: true,
      confirmAccept: false,
      liquidationData: {
        payDate: '',
        rightsDate: '',
        document: null,
        documentFile: null
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    borrarDocumento(){
      this.liquidationData.document = null;     
    },
    validarInputDocument(){
      this.confirmedDoc = false;
        return;        
    },
    validarInput(){
      this.confirmed = false;
        return;        
    },
    sendRequest(){

      if (this.liquidationData.document == null || this.liquidationData.documentFile.name == '') {
        this.error = 'Por favor adjunte el comprobante de pago';
        return false;
      }

      this.loading = true;
      let liquidationData = {
        "designRightsPayDate": null,
        "liquidationDate": null,
        "idRequest": this.requestDetail.id,
        "document": this.liquidationData.document,
        "documentName": this.liquidationData.documentFile.name,
        "updateDate": new Date(),
        "createDate": new Date(),
        "type": "voucher"
      }

      axios.post("liquidation/add", liquidationData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((result) => {
        this.loading = false;
        this.$router.go(-1);
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.';
      })
    },
    userActionLog(){
      let userAction = {
        "idRequest":this.requestDetail.id,
        "action": "Envió la liquidación de diseños",
        "email": localStorage.getItem('email'),
        "editedDate":new Date()
      }
      axios.post("userActionLogController/add", userAction, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(data =>{
        console.log("si agrego el log")
      })
      .catch((e) => {
        this.loading = false;
        this.error = 'no agrego el log';
      })
    },

    onFileChangeDocument(event){
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = () => {
        this.liquidationData.document  = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      this.liquidationData.documentFile = files;
    }
  },
  computed: {
    ...mapState({
      requestDetail: state => state.requestDetail
    })
  }
}
</script>

<style lang="scss">
.form {
  padding: 50px 0;
  .container {
    // background-color: #444444;
  }
  
}
</style>